var rtl_default = {
  "rtl": "WdrX8",
  "ltr": "xWJx0"
};
export {
  rtl_default as default
};
//# sourceMappingURL=rtl-scss.js.map
